// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"d4b3cd3a","583":"ad5758b8","651":"80559875","924":"73454c09"}[chunkId] + ".chunk.js";
};